export const downloadExampleMappingCSV = () => {
  const csvContent = `ip_address,tags
192.168.1.0/24,"internal,production"
10.0.0.1-10.0.0.100,"office,workstation"
172.16.0.5,"server,critical"
192.168.99.12/30,"dmz,public"
10.1.0.1,"backup,storage"`;

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', 'IP Mapping Example.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const validateCSVFormat = (file: File): Promise<string[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const csv = e.target?.result as string;
      const lines = csv.split('\n');
      const errors: string[] = [];

      if (lines.length < 2) {
        errors.push('CSV must have at least a header row and one data row');
      }

      const header = lines[0].toLowerCase().trim();
      if (!header.includes('ip_address') || !header.includes('tags')) {
        errors.push(
          'CSV must have "ip_address" and "tags" columns (case-insensitive)'
        );
      }

      resolve(errors);
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsText(file);
  });
};

export default downloadExampleMappingCSV;
